import { useEffect, useRef } from 'react';

/**
 * A variation of the usePrevious hook, which will only update the stored value when truthy
 */
export function usePreviousDefinedValue(value) {
  const ref = useRef(undefined);
  useEffect(() => {
    if (value) {
      ref.current = value;
    }
  }, [value]);
  return ref.current;
}